import { useEffect } from 'react';

export const useSidebarBodyLock = (isMobile: boolean, isOpen: boolean) => {
  useEffect(() => {
    if (isMobile && isOpen) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'unset';
      };
    }
  }, [isMobile, isOpen]);
};
